// extracted by mini-css-extract-plugin
export var chevronIcon = "_ad-2";
export var teamName = "_ad-1";
export var teamSwitcherButton = "_ad-0";